import { Color } from "@mui/material";
import { blue, purple } from "@mui/material/colors";
import { MetricsKey } from "@/components/pages/common/resources-ag-grid/utils/metrics/metricsTypes";
import {
  MetricPeriods,
  MetricsStatsType,
  ResourceDetailsMetricKey,
} from "@/components/pages/common/resource-details/utils/types/metrics";
import { ResourceType } from "@/services/cloudchipr.api";

export const colorsByMetricType = new Map<MetricsKey, Color>([
  ["memory_used_bytes", purple],
  ["memory_used_percent", purple],
  ["mem_used_percent_max", purple],
  ["mem_available_percent_min", purple],
  ["cpu_max", blue],
  ["cpu_cores", blue],
  ["cpu_percent", blue],
  ["total_connection_sum", blue],
  ["all_request_sum", blue],
  ["processed_bytes", blue],

  ["provisioned_concurrency_usage_sum", blue],
  ["total_compute_usage", blue],
  ["requests_sum", blue],
]);

export const metricsLabel: Record<MetricsKey, string> = {
  cpu_max: "Max CPU",
  cpu_cores: "Max CPU",
  cpu_percent: "Max CPU",
  total_connection_sum: "Connections",
  all_request_sum: "Requests",
  memory_used_bytes: "Memory Max",
  memory_used_percent: "Memory Max",
  mem_used_percent_max: "Memory Max",
  mem_available_percent_min: "Unused Memory",
  processed_bytes: "Traffic Sum",
  total_compute_usage: "Total Compute Usage",
  requests_sum: "Requests Sum",
  provisioned_concurrency_usage_sum: "Provisioned Concurrency Usage",
};

export const metricsUnit: Record<MetricsKey, string> = {
  cpu_max: "%",
  cpu_cores: "%",
  cpu_percent: "%",
  total_connection_sum: "Connections",
  all_request_sum: "Requests",
  memory_used_bytes: "%",
  memory_used_percent: "%",
  mem_used_percent_max: "%",
  mem_available_percent_min: "%",
  processed_bytes: "Mb",
  total_compute_usage: "GB-seconds",
  requests_sum: "Requests",
  provisioned_concurrency_usage_sum: "Count",
};

export const metricsFrequencies: Partial<Record<MetricsKey, string>> = {
  total_compute_usage: "24h",
  provisioned_concurrency_usage_sum: "24h",
  requests_sum: "24h",
};

export const metricsDefaultState: Partial<
  Record<ResourceDetailsMetricKey, MetricsStatsType>
> = {
  total_compute_usage: "sum",
};

export const metricsDrawerDefaultPeriod: Partial<
  Record<ResourceType, MetricPeriods>
> = {
  lambda: "24h",
};
